import React, { useEffect, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import BottomNav from './components/BottomNav';
import Toast from './components/Toast';
import { trackPageView } from './utils/analytics';
import dataTracker from './utils/dataTracker';

// Критичные компоненты загружаем сразу (Header, Footer, etc)
// Остальные загружаем лениво
const Home = React.lazy(() => import('./pages/Home'));
const FullPrediction = React.lazy(() => import('./pages/FullPrediction'));
const Accumulators = React.lazy(() => import('./pages/Accumulators'));
const Bonuses = React.lazy(() => import('./pages/Bonuses'));
const BonusesBangladesh = React.lazy(() => import('./pages/BonusesBangladesh'));
const BonusesIndia = React.lazy(() => import('./pages/BonusesIndia'));
const BonusesPakistan = React.lazy(() => import('./pages/BonusesPakistan'));
const BonusesNigeria = React.lazy(() => import('./pages/BonusesNigeria'));
const BonusesKenya = React.lazy(() => import('./pages/BonusesKenya'));
const BonusesCameroon = React.lazy(() => import('./pages/BonusesCameroon'));
const BonusesEthiopia = React.lazy(() => import('./pages/BonusesEthiopia'));
const BonusesGhana = React.lazy(() => import('./pages/BonusesGhana'));
const BonusesPhilippines = React.lazy(() => import('./pages/BonusesPhilippines'));
const BonusesTanzania = React.lazy(() => import('./pages/BonusesTanzania'));
const BonusesUganda = React.lazy(() => import('./pages/BonusesUganda'));
const BonusesDetail = React.lazy(() => import('./pages/BonusesDetail'));
const Guides = React.lazy(() => import('./pages/Guides'));
const GuideDetail = React.lazy(() => import('./pages/GuideDetail'));
const NotFound = React.lazy(() => import('./pages/NotFound'));
const PredictionsTags = React.lazy(() => import('./pages/PredictionsTags'));
const About = React.lazy(() => import('./pages/About'));
const PrivacyPolicy = React.lazy(() => import('./pages/PrivacyPolicy'));
const PostingInsta = React.lazy(() => import('./pages/PostingInsta'));
const AdminPanel = React.lazy(() => import('./pages/AdminPanel'));

// Компонент загрузчика
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
  </div>
);

const App = () => {
  const location = useLocation();
  const isPostingPage = location.pathname === '/posting-insta';

  // Отслеживание навигации между страницами
  useEffect(() => {
    // Отслеживаем просмотр страницы
    trackPageView(location.pathname, document.title);
    dataTracker.trackPageView(location.pathname);
    
    // Прокручиваем наверх при смене страницы
    window.scrollTo(0, 0);
  }, [location]);

  // Инициализация системы уведомлений (один раз при загрузке приложения)
  useEffect(() => {
    dataTracker.initialize();
  }, []);

  return (
    <div className={`min-h-screen flex flex-col ${isPostingPage ? 'posting-mode' : ''}`}>
      {!isPostingPage && <Header />}
      
      <main className="flex-grow">
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/accumulators/" element={<Accumulators />} />
            <Route path="/bookie-bonuses/" element={<Bonuses />} />
            <Route path="/bonuses-bangladesh" element={<BonusesBangladesh />} />
            <Route path="/bonuses-india" element={<BonusesIndia />} />
            <Route path="/bonuses-pakistan" element={<BonusesPakistan />} />
            <Route path="/bonuses-nigeria" element={<BonusesNigeria />} />
            <Route path="/bonuses-kenya" element={<BonusesKenya />} />
            <Route path="/bonuses-cameroon" element={<BonusesCameroon />} />
            <Route path="/bonuses-ethiopia" element={<BonusesEthiopia />} />
            <Route path="/bonuses-ghana" element={<BonusesGhana />} />
            <Route path="/bonuses-philippines" element={<BonusesPhilippines />} />
            <Route path="/bonuses-tanzania" element={<BonusesTanzania />} />
            <Route path="/bonuses-uganda" element={<BonusesUganda />} />
            <Route path="/bookie-bonuses/:slug" element={<BonusesDetail />} />
            <Route path="/betting-guides/" element={<Guides />} />
            <Route path="/betting-guides/:slug" element={<GuideDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/djimbo" element={<AdminPanel />} />
            <Route path="/1xbet-predictions" element={<PredictionsTags />} />
            <Route path="/melbet-predictions" element={<PredictionsTags />} />
            <Route path="/betwinner-predictions" element={<PredictionsTags />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="/:slug" element={<FullPrediction />} />
            <Route path="/posting-insta" element={<PostingInsta />} />
            {/* Catch-all route for 404 errors */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      
      <Footer />
      {!isPostingPage && <BottomNav />}
      
      {/* Toast Notifications System */}
      <Toast />
    </div>
  );
};

export default App; 